module.exports = "../images/fishing-lodge-2-19.jpg?v=a34ba74";